export default __webpack_public_path__ + "static/media/shopping.c61d4a5d.svg";